import { FIELD_IS_VALID } from "../../../Constants";

const validateLanguage = (language, _record) => {
    if (!language) {
        return 'record_validation_language_selection_is_empty';
    }

    if (!language || language.length === 0) {
        return 'record_validation_language_selection_is_empty';
    }

    return FIELD_IS_VALID;
};

export default validateLanguage;